"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenLabsVoiceModel = void 0;
exports.ElevenLabsVoiceModel = {
    ElevenMultilingualV2: "eleven_multilingual_v2",
    ElevenTurboV2: "eleven_turbo_v2",
    ElevenTurboV25: "eleven_turbo_v2_5",
    ElevenFlashV2: "eleven_flash_v2",
    ElevenFlashV25: "eleven_flash_v2_5",
    ElevenMonolingualV1: "eleven_monolingual_v1",
};
